const BASE_URL = "https://d392t2kbzfe6yu.cloudfront.net/config/web-photo";

const getImageUrl = (filename) => `${BASE_URL}/${filename}`;

export const IMAGES = {
	"AppDescriptionPage-RewardPic3.png": getImageUrl(
		"AppDescriptionPage-RewardPic3.png"
	),
	"AboutUsPage-Img1.png": getImageUrl("AboutUsPage-Img1.png"),
	"AboutUsPage-Img2.png": getImageUrl("AboutUsPage-Img2.png"),
	"AboutUsPage-MissionStatement.png": getImageUrl(
		"AboutUsPage-MissionStatement.png"
	),
	"AppDescriptionPage-android_app_download.svg": getImageUrl(
		"AppDescriptionPage-android_app_download.svg"
	),
	"AppDescriptionPage-DownloadAppImg.png": getImageUrl(
		"AppDescriptionPage-DownloadAppImg.png"
	),
	"AppDescriptionPage-ios_app_download.jpg": getImageUrl(
		"AppDescriptionPage-ios_app_download.jpg"
	),
	"AppDescriptionPage-PlayerBenefit.png": getImageUrl(
		"AppDescriptionPage-PlayerBenefit.png"
	),
	"AppDescriptionPage-RewardPic1.png": getImageUrl(
		"AppDescriptionPage-RewardPic1.png"
	),
	"AppDescriptionPage-RewardPic2.png": getImageUrl(
		"AppDescriptionPage-RewardPic2.png"
	),
	"HomePage-AboutUs.png": getImageUrl("HomePage-AboutUs.png"),
	"HomePage-AboutWSOM.png": getImageUrl("HomePage-AboutWSOM.png"),
	"HomePage-BecomeAPlayer.png": getImageUrl("HomePage-BecomeAPlayer.png"),
	"HomePage-EventFallback.png": getImageUrl("HomePage-EventFallback.png"),
	"HomePage-HostVenue.png": getImageUrl("HomePage-HostVenue.png"),
	"HomePage-LatestNews.png": getImageUrl("HomePage-LatestNews.png"),
	"HomePage-shop.png": getImageUrl("HomePage-shop.png"),
	"HostVenuePage-BecomeAHost.png": getImageUrl(
		"HostVenuePage-BecomeAHost.png"
	),
	"HostVenuePage-Benefit1.png": getImageUrl("HostVenuePage-Benefit1.png"),
	"HostVenuePage-Benefit2.png": getImageUrl("HostVenuePage-Benefit2.png"),
	"HostVenuePage-Benefit3.png": getImageUrl("HostVenuePage-Benefit3.png"),
	"HostVenuePage-Benefit4.png": getImageUrl("HostVenuePage-Benefit4.png"),
	"Icon.png": getImageUrl("Icon.png"),
	"LatestNewsPage-Img1.png": getImageUrl("LatestNewsPage-Img1.png"),
	"LatestNewsPage-Img2.png": getImageUrl("LatestNewsPage-Img2.png"),
	"LatestNewsPage-Img3.png": getImageUrl("LatestNewsPage-Img3.png"),
	"LatestNewsPage-Img4.png": getImageUrl("LatestNewsPage-Img4.png"),
	"MainBackground.png": getImageUrl("MainBackground.png"),
	"PhotoPage-Picture1.png": getImageUrl("PhotoPage-Picture1.png"),
	"PhotoPage-Picture2.png": getImageUrl("PhotoPage-Picture2.png"),
	"PhotoPage-Picture3.png": getImageUrl("PhotoPage-Picture3.png"),
	"ShopPage-Product1.png": getImageUrl("ShopPage-Product1.png"),
	"ShopPage-Product2.png": getImageUrl("ShopPage-Product2.png"),
	"ShopPage-Product3.png": getImageUrl("ShopPage-Product3.png"),
	"ShopPage-Product4.png": getImageUrl("ShopPage-Product4.png"),
};
